// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a0927755","453":"e3302311","455":"b5d5c067","977":"209b065a"}[chunkId] + ".chunk.js";
};